/**
 * Copyright (c) Microsoft Corporation. All rights reserved.  
 * Licensed under the MIT License.
 */
export default {
	"supportsInteractivity": true,
	"strongSeparation": {
		"spacing": 40,
		"lineThickness": 1,
		"lineColor": "#eeeeee"
	},
	"fontFamily": "\"Segoe UI\", sans-serif",
	"fontSizes": {
		"small": 12,
		"normal": 13,
		"medium": 15,
		"large": 17,
		"extraLarge": 19
	},
	"fontWeights": {
		"lighter": 200,
		"normal": 400,
		"bolder": 700
	},
	"colors": {
		"dark": {
			"normal": "#000000",
			"subtle": "#808c95"
		},
		"light": {
			"normal": "#ffffff",
			"subtle": "#88ffff"
		},
		"accent": {
			"normal": "#2e89fc",
			"subtle": "#802E8901"
		},
		"attention": {
			"normal": "#ffd800",
			"subtle": "#CCFFD800"
		},
		"good": {
			"normal": "#00ff00",
			"subtle": "#CC00FF00"
		},
		"warning": {
			"normal": "#ff0000",
			"subtle": "#CCFF0000"
		}
	},
	"imageSizes": {
		"small": 40,
		"medium": 64,
		"large": 96
	},
	"actions": {
		"maxActions": 100,
		"separation": {
			"spacing": 8
		},
		"buttonSpacing": 8,
		"stretch": false,
		"showCard": {
			"actionMode": "inlineEdgeToEdge",
			"inlineTopMargin": 16,
			"backgroundColor": "#00000000",
			"padding": {
				"top": 8,
				"right": 8,
				"bottom": 8,
				"left": 8
			}
		},
		"actionsOrientation": "vertical",
		"actionAlignment": "left"
	},
	"adaptiveCard": {
		"backgroundColor": "#00000000",
		"padding": {
			"left": 8,
			"top": 8,
			"right": 8,
			"bottom": 8
		}
	},
	"container": {
		"separation": {
			"spacing": 8
		},
		"normal": {
			"backgroundColor": "#00000000"
		},
		"emphasis": {
			"backgroundColor": "#eeeeee",
			"borderColor": "#aaaaaa",
			"borderThickness": {
				"top": 1,
				"right": 1,
				"bottom": 1,
				"left": 1
			},
			"padding": {
				"top": 8,
				"right": 8,
				"bottom": 8,
				"left": 8
			}
		}
	},
	"textBlock": {
		"color": "dark",
		"separations": {
			"small": {
				"spacing": 8
			},
			"normal": {
				"spacing": 8
			},
			"medium": {
				"spacing": 8
			},
			"large": {
				"spacing": 8
			},
			"extraLarge": {
				"spacing": 8
			}
		}
	},
	"image": {
		"size": "medium",
		"separation": {
			"spacing": 8
		}
	},
	"imageSet": {
		"imageSize": "medium",
		"separation": {
			"spacing": 8
		}
	},
	"factSet": {
		"separation": {
			"spacing": 8
		},
		"title": {
			"color": "dark",
			"size": "normal",
			"isSubtle": false,
			"weight": "bolder",
			"wrap": true,
			"maxWidth": 150
		},
		"value": {
			"color": "dark",
			"size": "normal",
			"isSubtle": false,
			"weight": "normal",
			"wrap": true
		},
		"spacing": 8
	},
	"input": {
		"separation": {
			"spacing": 8
		}
	},
	"columnSet": {
		"separation": {
			"spacing": 8
		}
	},
	"column": {
		"separation": {
			"spacing": 8
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/modals/AdaptiveCardViewer/AdaptiveCardHostConfig.ts